import { styled } from "styled-components";

export const NovoUsuarioContainer = styled.div`
  width: 76%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 60px;

  .box {
    width: 90%;
    height: 700px;
    background-color: var(--base);
    border-radius: 18px;
    padding-top: 10px;
  }

  .flex {
    align-items: center;

    svg {
      width: 45px;
      height: 45px;
    }

    h1 {
      font-size: 38px;
      font-weight: 700;
      margin-left: 10px;
      color: var(--principal);
    }
  }

  .filtro {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 50%;

    input {
      border: none;
      padding: 10px 3px;
      border-radius: 5px;
      width: 70%;
      height: 35px;
      font-size: 14px;
    }

    div {
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      margin-bottom: 25px;
      width: 35%;

      > p {
        font-size: 0.8rem;
        margin-bottom: 8px;
      }
    }

    select,
    option {
      width: 161px;
      padding: 5px;
      border-radius: 6px;
      border: none;
      outline: none;
      background: var(--amarelo);
      text-align: center;
      font-size: 0.8rem;
      color: var(--base);
      font-weight: 200;
    }
  }

  button {
    background-color: var(--amarelo);
    color: var(--principal);
  }
`;

export const BoxFiltros = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;

  button {
    background-color: var(--principal);
    color: var(--base);
    width: 20%;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 8px;
    border: none;
    border-radius: 20px;
  }
`;
